import { useEffect } from "react";
import { isEmbedded, initAppBridge, getSessionToken } from "../lib/appBridge";
import api from "../lib/api";

// When running inside Shopify admin, boot App Bridge and self-heal the
// offline access token via token exchange (no redirect OAuth needed).
export default function EmbeddedBridge() {
  useEffect(() => {
    if (!isEmbedded()) return;
    (async () => {
      await initAppBridge();
      const token = await getSessionToken();
      if (!token) return;
      try {
        await api.post("/shopify/token-exchange");
      } catch {
        /* silent — standalone OAuth remains available */
      }
    })();
  }, []);
  return null;
}
